var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-top-actions"},[(_vm.mutableOptions.number)?_c('sTooltip',{staticClass:"my-auto",attrs:{"border":false,"content":_vm.$t('Common.Copy'),"enterable":false,"placement":"bottom","type":"white"}},[_c('div',{staticClass:"item-top-actions_number",attrs:{"data-qa":"item-number"},on:{"click":_vm.copyItemNumber}},[_vm._v(" "+_vm._s(_vm.itemNumber)+" ")])]):_vm._e(),_c('ShareBlock',{staticClass:"my-auto ml-2",attrs:{"mode":"icon","options":{
      id: _vm.mutableOptions.id,
      number: _vm.mutableOptions.number,
      title: _vm.mutableOptions.title,
      shareLabel: _vm.mutableOptions.shareLabel,
      showParticipantsLink: _vm.mutableOptions.showParticipantsLink,
      participantsLink: _vm.mutableOptions.participantsLink,
      routeLinkOrg: _vm.mutableOptions.routeLinkOrg
    }}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }